<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
// import Swal from "sweetalert2";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import DefaultDashboard from "./components/DefaultDashboard.vue";
import SoalPenyusunDashboard from "./components/SoalPenyusunDashboard.vue";
import DashboardValidator from "./components/DashboardValidator.vue";

// Daftarkan static dashboard di sini.
// Untuk menambah static dashboard baru: buat component baru di ./components/,
// lalu tambahkan entry { id, nama_dashboard, component } ke array ini.
const STATIC_DASHBOARDS = [
  { id: "default", nama_dashboard: "Default", component: DefaultDashboard },
  { id: "soal-penyusun", nama_dashboard: "Dashboard Penyusun", component: SoalPenyusunDashboard },
  { id: "dashboard-validator", nama_dashboard: "Dashboard Validator", component: DashboardValidator },
];

export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, vSelect },
  data() {
    return {
      title: "Dashboard",

      selector: {
        list: STATIC_DASHBOARDS.map(({ id, nama_dashboard }) => ({ id, nama_dashboard })),
        selected: STATIC_DASHBOARDS[0],
        loading: false,
      },

      iframeDashboard: {
        link: null,
        loading: false,
      },
    };
  },

  computed: {
    activeStaticComponent() {
      const found = STATIC_DASHBOARDS.find((d) => d.id === this.selector.selected?.id);
      return found?.component || null;
    },
    isDynamic() {
      return !this.activeStaticComponent;
    },
  },

  async mounted() {
    await this.fetchDashboardList();
  },

  methods: {
    async fetchDashboardList() {
      this.selector.loading = true;
      await axios({
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/dashboard",
        method: "get",
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          const meta = res?.data?.meta;
          if (meta?.code != 200) return;

          const activeRole = localStorage.getItem("session_role_active_id");
          const dynamic = (res.data.data.data || [])
            .filter((item) => {
              if (!item.akses_role) return false;
              return item.akses_role.split(",").map((r) => r.trim()).includes(activeRole);
            })
            .map((item) => ({ id: item.id_dashboard, nama_dashboard: item.nama_dashboard }));

          // static list is always kept at the front
          const staticItems = STATIC_DASHBOARDS.map(({ id, nama_dashboard }) => ({ id, nama_dashboard }));
          this.selector.list = [...staticItems, ...dynamic];
        })
        .catch((err) => {
          console.error("Gagal mengambil list dashboard", err);
        })
        .finally(() => {
          this.selector.loading = false;
        });
    },

    async onSelectDashboard(dashboard) {
      this.iframeDashboard.link = null;
      this.selector.selected = dashboard;

      if (this.isDynamic) {
        await this.fetchIframeLink(dashboard.id);
      }
    },

    async fetchIframeLink(id) {
      this.iframeDashboard.loading = true;
      await axios({
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/dashboard/preview",
        method: "get",
        params: { id },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          if (res?.data?.meta?.code == 200) {
            this.iframeDashboard.link = res.data.data.link_dashboard || null;
          }
        })
        .catch((err) => {
          console.error("Gagal mengambil link dashboard", err);
        })
        .finally(() => {
          this.iframeDashboard.loading = false;
        });
    },

    reloadIframe() {
      const iframe = this.$refs.dashboardIframe;
      if (iframe) {
        iframe.src = "";
        this.$nextTick(() => {
          iframe.src = this.iframeDashboard.link;
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <!-- Selector -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title mb-3">Pilih Dashboard</div>
            <div class="col-md-4">
              <v-select
                v-model="selector.selected"
                :options="selector.list"
                :loading="selector.loading"
                label="nama_dashboard"
                placeholder="Pilih dashboard..."
                :clearable="false"
                @update:modelValue="onSelectDashboard($event)"
              >
                <template #option="{ nama_dashboard }">{{ nama_dashboard }}</template>
                <template #selected-option="{ nama_dashboard }">{{ nama_dashboard }}</template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Static Dashboard: render component yang sesuai -->
    <component :is="activeStaticComponent" v-if="activeStaticComponent" />

    <!-- Dynamic Dashboard: iframe -->
    <template v-else>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div v-if="iframeDashboard.loading" class="text-center py-4">
                <i class="fas fa-spinner fa-spin"></i> Memuat dashboard...
              </div>
              <template v-else-if="iframeDashboard.link">
                <button class="btn btn-primary mb-3" @click="reloadIframe">
                  <i class="fas fa-sync-alt me-1"></i> Reload
                </button>
                <iframe
                  ref="dashboardIframe"
                  :src="iframeDashboard.link"
                  width="100%"
                  height="800"
                  frameborder="0"
                ></iframe>
              </template>
              <div v-else class="text-center py-4 text-muted">
                Dashboard ini tidak memiliki link yang dapat ditampilkan.
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>
